import { render } from "./SpaceGallery.vue?vue&type=template&id=8cd78930"
import script from "./SpaceGallery.vue?vue&type=script&lang=js"
export * from "./SpaceGallery.vue?vue&type=script&lang=js"

import "./SpaceGallery.vue?vue&type=style&index=0&id=8cd78930&lang=stylus"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__